@defer (when menuStore.menuItems()) {
  <nb-menu tag="menu" [items]="menuStore.menuItems()" />
} @placeholder (minimum 500ms) {
  <nb-spinner status="primary" />
}
<div class="control-panel"></div>
